import {
  createContext,
  useContext,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";

const HomeUiContext = createContext(null);

export function HomeUiProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [stockLimit, setStockLimit] = useState(null);
  const remindSelectRentalDateImplRef = useRef(() => {});
  const toyModalClosersRef = useRef(new Set());

  const showStockLimit = useCallback((name, max) => {
    setStockLimit({ name, max });
  }, []);

  const closeStockLimit = useCallback(() => {
    setStockLimit(null);
  }, []);

  const registerRemindSelectRentalDate = useCallback((fn) => {
    remindSelectRentalDateImplRef.current =
      typeof fn === "function" ? fn : () => {};
  }, []);

  const remindSelectRentalDate = useCallback(() => {
    remindSelectRentalDateImplRef.current();
  }, []);

  const registerToyModalCloser = useCallback((fn) => {
    const closers = toyModalClosersRef.current;
    if (typeof fn !== "function") return () => {};
    closers.add(fn);
    return () => {
      closers.delete(fn);
    };
  }, []);

  const closeAllToyModals = useCallback(() => {
    toyModalClosersRef.current.forEach((close) => close());
  }, []);

  const value = useMemo(
    () => ({
      drawerOpen,
      openDrawer: () => setDrawerOpen(true),
      closeDrawer: () => setDrawerOpen(false),
      setDrawerOpen,
      stockLimit,
      showStockLimit,
      closeStockLimit,
      registerRemindSelectRentalDate,
      remindSelectRentalDate,
      registerToyModalCloser,
      closeAllToyModals,
    }),
    [
      drawerOpen,
      stockLimit,
      showStockLimit,
      closeStockLimit,
      registerRemindSelectRentalDate,
      remindSelectRentalDate,
      registerToyModalCloser,
      closeAllToyModals,
    ],
  );

  return (
    <HomeUiContext.Provider value={value}>{children}</HomeUiContext.Provider>
  );
}

export function useHomeUi() {
  const ctx = useContext(HomeUiContext);
  if (!ctx) {
    return {
      drawerOpen: false,
      openDrawer: () => {},
      closeDrawer: () => {},
      setDrawerOpen: () => {},
      stockLimit: null,
      showStockLimit: () => {},
      closeStockLimit: () => {},
      registerRemindSelectRentalDate: () => {},
      remindSelectRentalDate: () => {},
      registerToyModalCloser: () => () => {},
      closeAllToyModals: () => {},
    };
  }
  return ctx;
}
